import React, {Component} from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classNames from 'classnames';

export default class Speaker extends Component {
    static propTypes = {
        speaker: ImmutablePropTypes.map.isRequired,
    };

    shouldComponentUpdate(nextProps) {
        return nextProps.speaker !== this.props.speaker;
    }

    render() {
        const {speaker} = this.props;
        const className = classNames('cielo24-vwrap-speaker', {
            'cielo24-vwrap-highlight-result': speaker.getIn(['highlight', 'result']),
            'cielo24-vwrap-highlight-active-result': speaker.getIn(['highlight', 'activeResult']),
        });

        return (
            <span className={className}>
                <span className='cielo24-vwrap-highlight'>{speaker.get('displayAs')}</span>
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/transcript/speaker.js